<ng-container>
  <div class="w-full h-full flex appointment-case-dialog-container flex-col  max-w-3xl place-content-between">
    <div class="flex flex-col">
      <div class="flex flex-row place-content-between">
        <span class="text-lg font-semibold pb-9" style="font-family: 'Open Sans';">
          Add Appointment Case
        </span>
        <div class="cursor-pointer h-6 flex items-center" (click)="cancel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
            <path
              d="M8.65581 9.80657L2.75311 15.7685C2.53226 15.9916 2.25118 16.1031 1.90987 16.1031C1.56856 16.1031 1.28747 15.9916 1.06663 15.7685C0.845776 15.5455 0.735352 15.2616 0.735352 14.9168C0.735352 14.5721 0.845776 14.2882 1.06663 14.0651L6.96933 8.10315L1.06663 2.14117C0.845776 1.9181 0.735352 1.6342 0.735352 1.28946C0.735352 0.944721 0.845776 0.660817 1.06663 0.43775C1.28747 0.214683 1.56856 0.103149 1.90987 0.103149C2.25118 0.103149 2.53226 0.214683 2.75311 0.43775L8.65581 6.39973L14.5585 0.43775C14.7794 0.214683 15.0604 0.103149 15.4018 0.103149C15.7431 0.103149 16.0241 0.214683 16.245 0.43775C16.4658 0.660817 16.5763 0.944721 16.5763 1.28946C16.5763 1.6342 16.4658 1.9181 16.245 2.14117L10.3423 8.10315L16.245 14.0651C16.4658 14.2882 16.5763 14.5721 16.5763 14.9168C16.5763 15.2616 16.4658 15.5455 16.245 15.7685C16.0241 15.9916 15.7431 16.1031 15.4018 16.1031C15.0604 16.1031 14.7794 15.9916 14.5585 15.7685L8.65581 9.80657Z"
              fill="#0054A6" />
          </svg>
        </div>
      </div>

      <form class="flex flex-col w-full space-y-3" [formGroup]=appointmentCaseForm>
        <div class="flex flex-row place-content-between">
          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Submission Type <sup>*</sup></span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select formControlName="warrantySubmissionTypeId">
                <mat-option *ngFor="let st of dialogData.dropdowns.submissionTypes" [value]="st.id">
                  {{st.description}}
                </mat-option>

              </mat-select>
              <mat-error *ngIf="formSubmitted && appointmentCaseForm.get('warrantySubmissionTypeId').errors"
                class="text-sm">
                {{appointmentCaseForm.get('warrantySubmissionTypeId').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Op Code</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="opCode" matInput formControlName="opCode" oninput="this.value = this.value.toUpperCase()"
                autocomplete="off">
            </mat-form-field>
          </div>

          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Tech/Tech
              Group <sup>*</sup></span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select
                (selectionChange)="techOrGroupSelected($event.value,dialogData.dropdowns.technicians,dialogData.dropdowns.technicianGroups)"
                formControlName="techOrTechGroup">
                <mat-optgroup>
                  <label fxFlex class="w-full">
                    Tech Groups
                  </label>
                  <mat-option
                    *ngFor="let tg of dialogData.dropdowns.technicianGroups | filterBy: ['rooftopId']: dialogData.authenticatedEmployee.rooftopId | orderBy: 'description'"
                    [value]="tg.id">
                    {{tg.description}}
                  </mat-option>
                </mat-optgroup>
                <mat-optgroup>
                  <label fxFlex class="w-full">
                    Technicians
                  </label>
                  <mat-option
                    *ngFor="let tg of dialogData.dropdowns.technicians | filterBy: ['rooftopId']:  dialogData.authenticatedEmployee.rooftopId | sortNamesBy: ['lastName']"
                    [value]="tg.associateId">
                    {{tg.embedded.associate.lastName}}, {{tg.embedded.associate.firstName}}
                  </mat-option>
                </mat-optgroup>
              </mat-select>
              <mat-error *ngIf="formSubmitted && appointmentCaseForm.get('techOrTechGroup').errors" class="text-sm">
                {{appointmentCaseForm.get('techOrTechGroup').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row place-content-between">
          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Estimated Time
            </span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="estimatedTime" matInput formControlName="estimatedTime" autocomplete="off"
                (keydown)="validateNumber($event)" type="text" inputmode="numeric">
              <mat-error *ngIf="formSubmitted && appointmentCaseForm.get('estimatedTime').errors" class="text-sm">
                {{appointmentCaseForm.get('estimatedTime').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Recommended
              Time</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="recommendedHours" matInput formControlName="recommendedHours"
                (keydown)="validateNumber($event)" type="text" inputmode="numeric" autocomplete="off">
            </mat-form-field>
          </div>

          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Start
              Time</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="startTime" type="time" matInput formControlName="startTime" onfocus="this.showPicker()">
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-row space-x-6">
          <div class="flex flex-col w-3/10">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Campaign
              #</span>
            <mat-form-field appearance="outline" class="text-sm">
              <input id="campaignNumber" matInput formControlName="campaignNumber"
                oninput="this.value = this.value.toUpperCase()" autocomplete="off">
              <mat-error *ngIf="formSubmitted && appointmentCaseForm.get('campaignNumber').errors" class="text-sm">
                {{appointmentCaseForm.get('campaignNumber').errors | inputError}}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="flex flex-col flex-1 pl-2">
            <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">
              Service Group
            </span>
            <mat-form-field appearance="outline" class="text-sm">
              <mat-select name="serviceGroupId" formControlName="serviceGroupId" panelClass="service-group-select"
                (selectionChange)="serviceGroupSelected($event.value, dialogData.serviceGroups)">
                <mat-option *ngFor="let serviceGroup of dialogData.serviceGroups | orderBy: 'name'"
                  [value]="serviceGroup.id">
                  {{serviceGroup.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <div class="flex flex-col w-full">
          <span class="font-semibold text-sm mb-3" style="font-family: 'Open Sans'; color: #282828">Case
            Description <sup>*</sup></span>
          <mat-form-field appearance="outline" class="text-sm">
            <textarea id="requestDescription" matInput formControlName="requestDescription" rows="4"></textarea>
            <mat-error *ngIf="formSubmitted && appointmentCaseForm.get('requestDescription').errors" class="text-sm">
              {{appointmentCaseForm.get('requestDescription').errors | inputError}}
            </mat-error>
          </mat-form-field>
        </div>
        <div class="h-5">
          <div *ngIf="(basicWarrantyExpired$ | async) === true" class="flex flex-row space-x-4">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-5 h-5">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
            </svg>

            <span class="text-red-500 text-sm">Please note that the basic warranty has expired for this
              vehicle.</span>
          </div>
        </div>
      </form>
    </div>

    <div class="w-full bg-white">
      <div class="flex flex-row  items-center"
        [ngClass]="dialogData.caseToEdit ?  'place-content-end' : 'place-content-between'">
        <button (click)="serviceGroupSearch()" id="saveButton"
          class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
          [ngClass]="{'hidden': dialogData.caseToEdit}"
          [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}"
          style="font-family: 'Open Sans'; height: 34px" type="submit">
          <span class="text-white font-medium text-sm">Search</span>
        </button>
        <div class="flex flex-row space-x-3">
          <span (click)="cancel()" class="flex place-items-center place-content-center py-2.5 px-5 rounded-md"
            [ngStyle]="{ border: '1px solid #515251', cursor: 'pointer'}"
            style="font-family: 'Open Sans'; height: 34px">Cancel</span>
          <button (click)="save()" id="saveButton"
            class="flex place-items-center place-content-center py-2.5 px-5 rounded-md ml-3"
            [ngStyle]="{ background: 'rgba(0, 84, 166, 1)', cursor: 'pointer'}" [disabled]="false"
            style="font-family: 'Open Sans'; height: 34px" type="submit">
            <span class="text-white font-medium text-sm">{{dialogData.caseToEdit ? 'Save': 'Add'}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>